import script from "./combobox-input.vue?vue&type=script&setup=true&lang=js"
export * from "./combobox-input.vue?vue&type=script&setup=true&lang=js"

import "./combobox-input.vue?vue&type=style&index=0&id=561a610d&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561a610d"]])

export default __exports__